export default "__VITE_ASSET__DCFSFo5j__"